<template>
<div>

<div class="grid" v-if="data.quizresult.questionlist && data.quizresult.questionlist.calculate_points"> 

<template v-if="!data.quizresult.questionlist.only_percentage">
<div class="col-3">
<p class="font-bold mt-0">{{$store.state.languages.lang_phrases.puan}}:</p>
</div>

<div class="col-9">
<p class=" mt-0">
<span class="text-green-500 font-bold">{{data.quizresult.percentage_over_points}} / {{data.quizresult.points.toFixed(2)}}</span>
</p>
</div>
</template>


<div class="col-3">
<p class="font-bold mt-0">{{$store.state.languages.lang_phrases.basari_yuzdesi}}:</p>
</div>

<div class="col-9">
<p class=" mt-0">

<span class="text-primary  font-bold">{{data.quizresult.percentage}}%</span>
</p>
</div>

<template v-if="data.flowsupplier.flow.calculationattribute">
  <div class="col-3">
  <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.basari_durumu}}:</p>
  </div>

  <div class="col-9">
    <template v-if="data.flowsupplier.flow.calculationattribute.type=='select'">
      <p class="mt-0 font-bold" v-html="getOptionData(data.flowsupplier.flow.calculationattribute.options,data.flowsupplier.flow.calculationattribute.supplierattributes[0].attibutenumericalval)"></p>
    </template>
  </div>
    
  </template>

</div>
</div>
</template>

<script>
export default {

  name: 'QuizpointModule',
  props:["data"],
  data () {
    return {

    }
  },
  methods:{
    getOptionData(options,id)
    {
      let item = options.find(item=>item.id == id)
      if(item)
      {
        if(item.color)
        {
          return "<span style='color:#"+item.color+"'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
        else
        {
          return "<span class='text-primary'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
      }
      return null
    },
  }
}
</script>

<style lang="css" scoped>
</style>